<template>
  <div class="card bg-danger">
    <!-- <button @click="test">holi</button> -->
    <div class="card-header d-flex justify-content-md-around">
      <h4 class="font-weight-bold text-light col-5 my-0">¡ATENCIÓN!</h4>
      <h4 class="font-weight-bold text-light col-6 my-0">MODIFICACIONES</h4>
    </div>
    <div
      class="card-body text-dark font-weight-bold d-flex pb-4 justify-content-md-around"
    >
      <div class="col-md-5 shadow rounded bg-warning py-4">
        <template v-if="editInclusion.editAll">
          <template
            v-if="
              !filterStatusString &&
              !filterPlanString &&
              !filterFamilyString &&
              !filterSubFamilyString &&
              !filterShiftString &&
              !dateFilterString
            "
          >
            <h5 class="text-center">
              Estás a punto de moficiar todas las membresías de tu gimnasio
            </h5>
            <h6 class="text-center">
              Las
              <span class="bg-danger rounded p-1 text-dark">{{
                totalFilter
              }}</span>
              membresías existentes en tu gimnasio serán afectadas
            </h6>
          </template>
          <template v-else>
            <p class="text-uppercase">Afectarás a las membresías...</p>
            <div class="pl-2 ml-auto">
              <template v-if="filterStatusString && editInclusion.editAll">
                <p class="mb-1">
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ filterStatusString }}
                </p>
                <ul class="">
                  <li
                    v-for="(status, i) in filter.status"
                    :key="i"
                    class="mb-0"
                  >
                    {{ status }}
                  </li>
                </ul>
              </template>
              <template v-if="filterPlanString && editInclusion.editAll">
                <p class="mb-1">
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ filterPlanString }}
                </p>
                <ul class="">
                  <li v-for="(plan, i) in filter.plan" :key="i" class="mb-0">
                    {{ plan }}
                  </li>
                </ul>
              </template>
              <template
                v-if="
                  filterFamilyString &&
                  editInclusion.editAll &&
                  !filterPlanString
                "
              >
                <p class="mb-1">
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ filterFamilyString }}
                </p>
                <ul class="">
                  <li
                    v-for="(family, i) in filter.family"
                    :key="i"
                    class="mb-0"
                  >
                    {{ family }}
                  </li>
                </ul>
              </template>
              <template
                v-if="
                  filterSubFamilyString &&
                  editInclusion.editAll &&
                  !filterPlanString
                "
              >
                <p class="mb-1">
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ filterSubFamilyString }}
                </p>
                <ul class="">
                  <li
                    v-for="(subFamily, i) in filter.subFamily"
                    :key="i"
                    class="mb-0"
                  >
                    {{ subFamily }}
                  </li>
                </ul>
              </template>
              <template v-if="filterShiftString && editInclusion.editAll">
                <p class="mb-1">
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ filterShiftString }}
                </p>
                <ul class="">
                  <li v-for="(shift, i) in filter.shift" :key="i" class="mb-0">
                    {{ shift }}
                  </li>
                </ul>
              </template>
              <template v-if="filterBranchesString && editInclusion.editAll">
                <p class="mb-1">
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ filterBranchesString }}
                </p>
                <ul class="">
                  <li
                    v-for="(branch, i) in filter.branches"
                    :key="i"
                    class="mb-0"
                  >
                    {{ branch }}
                  </li>
                </ul>
              </template>
              <template v-if="dateFilterString && editInclusion.editAll">
                <p
                  v-for="(i, index) in dateFilterString"
                  class="mb-1"
                  :key="index"
                >
                  <i
                    class="fa fa-exclamation text-danger shadow fa-lg"
                    aria-hidden="true"
                  ></i>
                  {{ i }}
                </p>
              </template>
            </div>
          </template>
        </template>
        <template
          v-else-if="
            !editInclusion.editAll && editInclusion.editList.length > 0
          "
        >
          <p class="">
            Has seleccionado
            <small class="lead font-weight-bold bg-warning rounded p-1">{{
              editInclusion.editList.length
            }}</small>
            Membresías para editar
          </p>
        </template>
        <template v-else>
          <h4 class="text-light text-center font-weight-bold">
            SIN MEMBRESÍAS SELECCIONADAS
          </h4>
        </template>
        <hr />
        <label for="">PREVISUALIZAR: </label>
        <div class="d-flex flex-row flex-wrap">
          <div
            v-for="(nid, i) in editInclusionPreview"
            :key="i"
            class="col-3 d-flex px-1"
          >
            <el-tooltip :open-delay="170" placement="top">
              <template #content> {{ nid }} </template>
              <button
                type="button"
                class="btn btn-danger text-truncate w-auto"
                data-toggle="tooltip"
                data-placement="top"
                @click="preview(nid)"
              >
                {{ nid }}
              </button>
            </el-tooltip>
          </div>
          <div
            class="col-12 d-flex"
            v-if="nidOnPReview < editInclusion.editList.length"
          >
            <button
              class="btn btn-success mb-0 btn-sm mx-auto"
              @click="nidOnPReview = nidOnPReview + 4"
            >
              ver más
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-md-6 bg-light text-dark rounded shadow d-flex flex-wrap preview-container"
      >
        <!-- <p>Campos editados</p> -->
        <template v-if="!showingData && !previewIsLoading"
          ><h3>PREVISUALIZAR...</h3></template
        >
        <template v-else-if="previewIsLoading && !showingData">
          <div class="m-auto">
            <i class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </div>
        </template>
        <template v-else>
          <div class="d-flex justify-content-around col-12 py-3">
            <button
              type="button"
              class="btn my-auto rounded-pill"
              :class="
                showing === 'preview' ? 'btn-success' : 'btn-outline-success'
              "
              @click="showing = 'preview'"
            >
              PREVIEW
            </button>
            <button
              type="button"
              class="btn my-auto rounded-pill"
              :class="
                showing === 'compare' ? 'btn-success' : 'btn-outline-success'
              "
              @click="showing = 'compare'"
            >
              ORIGINAL
            </button>
          </div>
          <template v-if="!showShiftDetails">
            <div class="col-12 d-flex flex-row mb-0">
              <div class="col-8">
                <label for="">Nombre</label>
                <p class="border-bottom text-truncate mb-2">
                  {{
                    showingData.socio[0] && showingData.socio[0].nombreSocio
                      ? showingData.socio[0].nombreSocio
                      : "SIN DATOS"
                  }}
                </p>
              </div>
              <div class="col-4">
                <label for="">RUT</label>
                <p class="border-bottom mb-0">{{ showingData.rutSocio }}</p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-8">
                <label for="">Plan</label>
                <p class="border-bottom text-truncate mb-2">
                  {{ showingData.descripcionPlan }}
                </p>
              </div>
              <div class="col-4">
                <label for="">Estado</label>
                <p class="border-bottom mb-0">
                  {{
                    showingData.estadoPago
                      ? showingData.estadoPago[0].glosa
                      : "SIN DATOS"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row mb-2">
              <div class="col-4 border-right d-flex flex-column py-2">
                <small for="" class="mx-auto">Fecha Inicio</small>
                <p class="mx-auto">{{ showingData.fechaInicio }}</p>
              </div>
              <div
                class="col-4 d-flex flex-column py-2 border-right border-left text-center"
              >
                <small for="" class="text-nowrap">Fecha Vencimiento</small>
                <p class="mx-auto">{{ showingData.fechaVencimiento }}</p>
              </div>
              <div class="col-4 d-flex flex-column py-2">
                <small for="" class="mx-auto">Duración</small>
                <p class="mx-auto">
                  {{ showingData.duracionPlan }}
                  {{ showingData.unidadDuracionPlan[0].glosa.split(" ")[0] }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-4">
                <label for="">USO SESIONES</label>
                <p class="border-bottom">
                  {{ showingData.indicadorUsoSesiones ? "SI" : "NO" }}
                </p>
              </div>
              <div class="col-4">
                <label for="">VALOR</label>
                <p class="border-bottom">${{ showingData.valorPlan }}</p>
              </div>
              <div class="col-4">
                <div class="d-flex flex-row">
                  <label for="" class="ml-0 mr-auto">TURNO</label>
                  <i
                    v-if="showingData.turno"
                    class="fa fa-search ml-auto mr-2 text-info cursor-pointer"
                    aria-hidden="true"
                    @click="showShiftDetails = true"
                  ></i>
                </div>
                <p class="border-bottom text-truncate">
                  {{
                    showingData.turno
                      ? showingData.turno.descripcionTurno
                      : "NO EDITADO"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row mb-2">
              <div class="col-6 border-right d-flex flex-column py-2">
                <label for="" class="mx-auto">SESIONES CONSUMIDAS</label>
                <p class="mx-auto">{{ showingData.sesionesUtilizadas || 0 }}</p>
              </div>
              <div class="col-6 d-flex flex-column py-2">
                <label for="" class="mx-auto">SESIONES TOTALES</label>
                <p class="mx-auto">{{ showingData.sesionesLimite || 0 }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-12 d-flex flex-row">
              <div class="col-8">
                <label for="">NOMBRE DEL TURNO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{ showingData.turno.descripcionTurno }}
                </p>
              </div>
              <div class="col-4">
                <label for="">ID</label>
                <p class="border-bottom mb-2">
                  {{ showingData.turno ? showingData.turno.idTurno : 0 }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">LUNES</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.lunesAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.lunesAutorizado ? "Permitido" : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.lunesAutorizado
                      ? showingData.turno.lunesHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.lunesAutorizado
                      ? showingData.turno.lunesHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">MARTES</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.martesAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.martesAutorizado
                      ? "Permitido"
                      : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.martesAutorizado
                      ? showingData.turno.martesHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.martesAutorizado
                      ? showingData.turno.martesHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">MIERCOLES</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.miercolesAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.miercolesAutorizado
                      ? "Permitido"
                      : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.miercolesAutorizado
                      ? showingData.turno.miercolesHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.miercolesAutorizado
                      ? showingData.turno.miercolesHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">JUEVES</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.juevesAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.juevesAutorizado
                      ? "Permitido"
                      : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.juevesAutorizado
                      ? showingData.turno.juevesHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.juevesAutorizado
                      ? showingData.turno.juevesHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">VIERNES</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.viernesAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.viernesAutorizado
                      ? "Permitido"
                      : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.viernesAutorizado
                      ? showingData.turno.viernesHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.viernesAutorizado
                      ? showingData.turno.viernesHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">SABADO</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.sabadoAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.sabadoAutorizado
                      ? "Permitido"
                      : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.sabadoAutorizado
                      ? showingData.turno.sabadoHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.sabadoAutorizado
                      ? showingData.turno.sabadoHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="col-12 d-flex flex-row">
              <div class="col-3">
                <label for="" class="mb-0">DÍA</label>
                <p class="border-bottom mb-2 text-truncate">DOMINGO</p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">ACCESO</label>
                <small
                  class="text-truncate text-light border-rounded px-2 py-1 font-weight-bold rounded-pill"
                  :class="
                    showingData.turno.domingoAutorizado
                      ? 'bg-success'
                      : 'bg-danger'
                  "
                >
                  {{
                    showingData.turno.domingoAutorizado
                      ? "Permitido"
                      : "Denegado"
                  }}
                </small>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">INICIO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.domingoAutorizado
                      ? showingData.turno.domingoHoraInicio
                      : "--:--:--"
                  }}
                </p>
              </div>
              <div class="col-3">
                <label for="" class="mb-0">TERMINO</label>
                <p class="border-bottom mb-2 text-truncate">
                  {{
                    showingData.turno.domingoAutorizado
                      ? showingData.turno.domingoHoraTermino
                      : "--:--:--"
                  }}
                </p>
              </div>
            </div>
            <div class="row col-12">
              <button
                class="btn rounded-circle return-button px-2 btn-danger"
                @click="showShiftDetails = false"
              >
                <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
              </button>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="card-footer d-flex">
      <FadeTransition :duration="100">
        <div
          class="card mx-auto px-5 py-4"
          v-if="confirmCounter < validationMax"
        >
          <h5 class="text-danger font-weight-bold my-auto">
            Debes previsualizar {{ validationMax - confirmCounter || 0 }}
            {{
              validationMax - confirmCounter === 1 ? "membresía" : "membresías"
            }}
            antes de continuar!
          </h5>
        </div>
      </FadeTransition>
      <FadeTransition :duration="500" :delay="250">
        <button
          v-if="confirmCounter >= validationMax"
          class="btn btn-warning text-dark btn-lg rounded-pill mx-auto"
          @click="handleContinue"
        >
          <i
            class="fa fa-exclamation-triangle text-danger bg-light p-1 rounded-circle"
            aria-hidden="true"
          ></i>
          continuar
          <i
            class="fa fa-exclamation-triangle text-danger bg-light p-1 rounded-circle"
            aria-hidden="true"
          ></i>
        </button>
      </FadeTransition>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import { FadeTransition } from "vue2-transitions";
export default {
  name: "alert",
  props: {
    editInclusion: {
      type: Object,
      default: () => {
        return {
          editList: [],
          editAll: false,
        };
      },
    },
    filter: {
      type: Object,
      default: () => {
        return {
          status: [],
          plan: [],
          family: [],
          subFamily: [],
          shift: [],
          branches: [],
          dateFilter: {},
        };
      },
    },
    totalFilter: {
      type: Number,
      default: 0,
    },
    previewData: {
      type: Object,
      default: () => {
        return {
          descripcionPlan: "PLAN CONVENIO",
          duracionPlan: 4,
          estadoPago: [{ glosa: "VIGENTE" }],
          fechaInicio: "15-07-2024",
          fechaVencimiento: "18-11-2024",
          fechaVigencia: "18-11-2024",
          idPlan: 45,
          rutSocio: "18030522-K",
          sesionesLimite: 0,
          sesionesUtilizadas: 1,
          valorPlan: 500,
        };
      },
    },
    compareData: {
      type: Object,
      default: () => {
        return {
          descripcionPlan: "PLAN CONVENIO",
          duracionPlan: 4,
          estadoPago: [{ glosa: "VIGENTE" }],
          fechaInicio: "15-07-2024",
          fechaVencimiento: "18-11-2024",
          fechaVigencia: "18-11-2024",
          idPlan: 45,
          rutSocio: "18030522-K",
          sesionesLimite: 0,
          sesionesUtilizadas: 1,
          valorPlan: 500,
        };
      },
    },
  },
  data() {
    return {
      previewIsLoading: false,
      nidOnPReview: 20,
      showing: "",
      showingData: false,
      showShiftDetails: false,
      confirmCounter: 0,
    };
  },
  components: {
    [Tooltip.name]: Tooltip,
    FadeTransition,
  },
  watch: {
    showing(value) {
      // console.log(value);
      if (value === "preview") {
        this.showingData = _.cloneDeep(this.previewData);
      } else if (value === "compare") {
        // console.log(this.compareData);
        this.showingData = _.cloneDeep(this.compareData);
      } else {
        this.showingData = false;
      }
    },
  },
  computed: {
    validationMax() {
      return this.editInclusionPreview.length < 5
        ? this.editInclusionPreview.length
        : 5;
    },
    editInclusionPreview() {
      if (this.editInclusion.editList.length > this.nidOnPReview) {
        return this.editInclusion.editList.slice(0, this.nidOnPReview);
      } else {
        return this.editInclusion.editList;
      }
    },
    filterStatusString() {
      if (this.filter.status.length === 0) {
        return false;
      } else {
        let message;
        if (this.filter.status.length > 0) {
          const statusFilterString =
            this.filter.status.length === 1 ? `En estado:` : `En estado:`;
          message = statusFilterString;
        }
        return message;
      }
    },
    filterPlanString() {
      if (this.filter.plan.length === 0) {
        return false;
      } else {
        let message;

        if (this.filter.plan.length > 0) {
          const planFilterString =
            this.filter.plan.length === 1
              ? `Pertenecientes al plan:`
              : `Pertenecientes a los planes:`;

          message = planFilterString;
        }
        return message;
      }
    },
    filterFamilyString() {
      if (this.filter.family.length === 0) {
        return false;
      } else {
        let message;
        if (this.filter.family.length > 0) {
          const familyFilterString =
            this.filter.family.length === 1
              ? `Pertenecientes a la familia:`
              : `Pertenecientes a las familias:`;
          message = familyFilterString;
        }

        return message;
      }
    },
    filterSubFamilyString() {
      if (this.filter.subFamily.length === 0) {
        return false;
      } else {
        let message;
        if (this.filter.subFamily.length > 0) {
          const subFamilyFilterString =
            this.filter.subFamily.length === 1
              ? `Pertenecientes a la sub-familia:`
              : `Pertenecientes a las sub-familias:`;
          message = subFamilyFilterString;
        }

        return message;
      }
    },
    filterShiftString() {
      if (this.filter.shift.length === 0) {
        return false;
      } else {
        let message;
        if (this.filter.shift.length > 0) {
          const shiftFilterString =
            this.filter.shift.length === 1
              ? `Con ingreso durante el turno:`
              : `Con ingreso durante los turnos:`;
          message = shiftFilterString;
        }

        return message;
      }
    },
    filterBranchesString() {
      if (this.filter.branches.length === 0) {
        return false;
      } else {
        let message;
        if (this.filter.branches.length > 0) {
          const branchesFilterString =
            this.filter.branches.length === 1
              ? `Asignadas en la sucursal:`
              : `Asignadas en las sucursales:`;
          message = branchesFilterString;
        }

        return message;
      }
    },
    dateFilterString() {
      if (!this.filter || !this.filter.dateFilter) {
        return false;
      } else {
        let messageArr = [];
        if (this.filter.dateFilter.endGTE && this.filter.dateFilter.endLTE) {
          messageArr.push(
            `Con fecha de [VENCIMIENTO] entre el ${this.filter.dateFilter.endGTE} y ${this.filter.dateFilter.endLTE}`
          );
        } else if (
          this.filter.dateFilter.endGTE &&
          !this.filter.dateFilter.endLTE
        ) {
          messageArr.push(
            `Con fecha de [VENCIMIENTO] posterior al ${this.filter.dateFilter.endGTE}`
          );
        } else if (
          this.filter.dateFilter.endLTE &&
          !this.filter.dateFilter.endGTE
        ) {
          messageArr.push(
            `Con fecha de [VENCIMIENTO] previo al ${this.filter.dateFilter.endLTE}`
          );
        }
        if (
          this.filter.dateFilter.beginingGTE &&
          this.filter.dateFilter.beginingLTE
        ) {
          messageArr.push(
            `Con fecha de [INICIO] entre el ${this.filter.dateFilter.beginingGTE} y ${this.filter.dateFilter.beginingLTE}`
          );
        } else if (
          this.filter.dateFilter.beginingGTE &&
          !this.filter.dateFilter.beginingLTE
        ) {
          messageArr.push(
            `Con fecha de [INICIO] posterior al ${this.filter.dateFilter.beginingGTE}`
          );
        } else if (
          this.filter.dateFilter.beginingLTE &&
          !this.filter.dateFilter.beginingGTE
        ) {
          messageArr.push(
            `Con fecha de [INICIO] previo al ${this.filter.dateFilter.beginingLTE}`
          );
        }

        return messageArr.length > 0 ? messageArr : false;
      }
    },
  },
  methods: {
    test() {
      console.log(!this.showingData && !this.previewIsLoading);
      console.log(this.previewIsLoading && !this.showingData);
      console.log(this.showingData);
      console.log(this.previewIsLoading);
      // console.log(!this.filterStatusString);
      // console.log(!this.filterPlanString);
      // console.log(!this.filterFamilyString);
      // console.log(!this.filterSubFamilyString);
      // console.log(!this.filterShiftString);
      // console.log(!this.dateFilterString);
      // console.log(this.dateFilterString);
      // console.log(
      //   !this.filterStatusString &&
      //     !this.filterPlanString &&
      //     !this.filterFamilyString &&
      //     !this.filterSubFamilyString &&
      //     !this.filterShiftString &&
      //     !this.dateFilterString
      // );
    },
    handleContinue() {
      this.$emit("continue");
    },
    togglePreviewIsLoading(value) {
      this.previewIsLoading = !!value;
    },
    toggleShowingData(value) {
      switch (value) {
        case 1:
          this.showing = "preview";
          break;
        case 2:
          this.showing = "compare";
          break;
        default:
          this.showing = "";
          break;
      }
    },
    preview(nid) {
      this.showShiftDetails = false;
      this.$emit("preview", nid);
    },
    confirmCounterAdd() {
      this.confirmCounter++;
    },
    close() {
      this.previewIsLoading = false;
      this.showing = "";
      this.showingData = false;
    },
  },
  beforeDestroy() {
    this.confirmCounter = 0;
  },
};
</script>

<style>
.return-button {
  height: 40px;
  width: 40px;
}
.preview-container {
  max-height: 550px;
}
</style>
